// WithMessagePinData.js
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import WithMessagePinData from '../component/WithMessagePinData.jsx';

import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { messageId, profileListType }) => {
  const meId = getMeData(state, 'id');
  const senderId = getMessageData(state, messageId, 'senderId');
  const { intersectedFeedName: pinFeedAlias } = senderId
    ? getSelectedQueryOptionObject(
        state,
        getFeedName(
          state,
          PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType],
          '{USER_ID}',
          senderId
        ),
        '',
        getRemoteConfigData(
          state,
          `${PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType]}_${
            QueryPrefix[QueryType.SORT]
          }`
        )?.[0]
      )
    : {};
  return {
    meId,
    messageId,
    pinFeedAlias,
    pinnedItemIds: getListData(
      state,
      [
        'home',
        getReturnType({ feedName: pinFeedAlias }),
        pinFeedAlias,
        'pinned',
      ],
      'itemIds'
    ),
    senderId,
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      meId,
      profileListType
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    updateProfileFeedUnixTimestamp: ({ unixTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['profileFeed'],
          data: {
            unixTimestamp,
          },
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithMessagePinData);
